import { Controller } from "@hotwired/stimulus";
import { saveBundle, loadBundle, loadQueue, clearQueue } from "../lib/offline_store";

// Drives the download + sync status on the performance picker. Writes the
// bundle to localStorage so the scanner page (same origin) can read it offline.
export default class extends Controller {
  static targets = ["downloadStatus", "syncStatus"];
  static values = { bundleUrl: String, syncUrl: String, performanceId: String };

  connect() {
    this.renderDownloadStatus();
    this.renderSyncStatus();
  }

  async download() {
    this.downloadStatusTarget.textContent = "Lädt …";
    const response = await fetch(this.bundleUrlValue);
    if (!response.ok) {
      this.downloadStatusTarget.textContent = "Fehler beim Herunterladen";
      return;
    }
    const data = await response.json();
    saveBundle(this.performanceIdValue, data.tickets);
    this.renderDownloadStatus();
  }

  async sync() {
    if (this.syncing) return;
    const queue = loadQueue(this.performanceIdValue);
    if (queue.length === 0) return;

    this.syncing = true;
    this.syncStatusTarget.textContent = "Synchronisiert …";
    try {
      const response = await fetch(this.syncUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({ scans: queue.map((s) => ({ code: s.code, scanned_at: s.scannedAt })) }),
      });

      if (response.ok) {
        clearQueue(this.performanceIdValue);
        this.renderSyncStatus();
      } else {
        this.syncStatusTarget.textContent = `${queue.length} ausstehend (Fehler)`;
      }
    } catch {
      // Network down / fetch threw: leave the queue intact and tell the operator.
      this.syncStatusTarget.textContent = `${queue.length} ausstehend (Fehler)`;
    } finally {
      this.syncing = false;
    }
  }

  renderDownloadStatus() {
    const bundle = loadBundle(this.performanceIdValue);
    this.downloadStatusTarget.textContent = bundle
      ? `Heruntergeladen: ${bundle.tickets.length} Tickets`
      : "Nicht heruntergeladen";
  }

  renderSyncStatus() {
    const pending = loadQueue(this.performanceIdValue).length;
    this.syncStatusTarget.textContent = pending ? `${pending} ausstehend` : "Synchronisiert";
  }
}
